import { render, staticRenderFns } from "./EditUserRelationship.vue?vue&type=template&id=1592fc1e&scoped=true&"
import script from "./EditUserRelationship.vue?vue&type=script&lang=ts&"
export * from "./EditUserRelationship.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1592fc1e",
  null
  
)

export default component.exports